import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4">
        {/* Disclaimer */}
        <div className="mb-8 pb-8 border-b border-gray-200">
          <div className="flex items-start max-w-4xl mx-auto">
            <AlertCircle className="h-5 w-5 text-gray-500 mr-3 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-gray-600">
              <p className="font-medium mb-2">Not healthcare. Not for crisis.</p>
              <p>
                US: 988 | UK: 116 123 | AU: 13 11 14 | CA: 1-833-456-4566
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-lg font-semibold text-ink-950 mb-4">VZMO</h3>
            <p className="text-gray-600 text-sm">
              Daily reps. Clear standards. Respect first.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-ink-950 mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/features" className="text-gray-600 hover:text-gold-500 transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-600 hover:text-gold-500 transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-gold-500 transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-ink-950 mb-4">Compare</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/compare/headspace-alternative" className="text-gray-600 hover:text-gold-500 transition-colors">
                  vs Headspace
                </Link>
              </li>
              <li>
                <Link to="/compare/calm-alternative" className="text-gray-600 hover:text-gold-500 transition-colors">
                  vs Calm
                </Link>
              </li>
              <li>
                <Link to="/compare/betterhelp-alternative" className="text-gray-600 hover:text-gold-500 transition-colors">
                  vs BetterHelp
                </Link>
              </li>
              <li>
                <Link to="/compare/strawberry-me-alternative" className="text-gray-600 hover:text-gold-500 transition-colors">
                  vs Strawberry.me
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-ink-950 mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-gold-500 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/creators" className="text-gray-600 hover:text-gold-500 transition-colors">
                  For Creators
                </Link>
              </li>
              <li>
                <a href="mailto:team@vzmo.ai" className="text-gray-600 hover:text-gold-500 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-ink-950 mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal/privacy" className="text-gray-600 hover:text-gold-500 transition-colors">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="text-gray-600 hover:text-gold-500 transition-colors">
                  Terms
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 text-center">
          <div className="text-sm text-gray-500">
            © {new Date().getFullYear()} VZMO. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
